/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type pages_index_QueryVariables = {};
export type pages_index_QueryResponse = {
    readonly currentMetaData: {
        readonly id: string;
        readonly year: number | null;
        readonly startDate: string;
        readonly endDate: string;
        readonly interestForm: string | null;
        readonly collaborators: ReadonlyArray<{
            readonly id: string;
            readonly name: string;
            readonly logo: string | null;
            readonly url: string | null;
            readonly description: string;
        }> | null;
        readonly companiesFirstDay: ReadonlyArray<{
            readonly id: string;
            readonly name: string;
            readonly logo: string | null;
            readonly url: string | null;
        }> | null;
        readonly companiesLastDay: ReadonlyArray<{
            readonly id: string;
            readonly name: string;
            readonly logo: string | null;
            readonly url: string | null;
        }> | null;
        readonly mainCollaborator: {
            readonly id: string;
            readonly name: string;
            readonly logo: string | null;
            readonly url: string | null;
            readonly description: string;
            readonly intro: string | null;
            readonly video: string | null;
            readonly poster: string | null;
        } | null;
        readonly " $fragmentRefs": FragmentRefs<"WelcomeScreen_currentMetaData">;
    };
    readonly events: ReadonlyArray<{
        readonly id: string;
        readonly title: string;
        readonly date: string;
        readonly timeStart: string;
        readonly timeEnd: string;
        readonly location: string;
    }> | null;
};
export type pages_index_Query = {
    readonly response: pages_index_QueryResponse;
    readonly variables: pages_index_QueryVariables;
};



/*
query pages_index_Query {
  currentMetaData {
    ...WelcomeScreen_currentMetaData
    id
    year
    startDate
    endDate
    interestForm
    collaborators {
      id
      name
      logo(width: 459, height: 170)
      url
      description
    }
    companiesFirstDay {
      id
      name
      logo(width: 320, height: 120)
      url
    }
    companiesLastDay {
      id
      name
      logo(width: 320, height: 120)
      url
    }
    mainCollaborator {
      id
      name
      logo(width: 1000, height: 320)
      url
      description
      intro
      video
      poster
    }
  }
  events {
    id
    title
    date
    timeStart
    timeEnd
    location
  }
}

fragment Countdown_currentMetaData on MetaData {
  startDate
  endDate
}

fragment WelcomeScreen_currentMetaData on MetaData {
  year
  startDate
  endDate
  interestForm
  ...Countdown_currentMetaData
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "year",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDate",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "interestForm",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "Company",
  "kind": "LinkedField",
  "name": "collaborators",
  "plural": true,
  "selections": [
    (v0/*: any*/),
    (v5/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "height",
          "value": 170
        },
        {
          "kind": "Literal",
          "name": "width",
          "value": 459
        }
      ],
      "kind": "ScalarField",
      "name": "logo",
      "storageKey": "logo(height:170,width:459)"
    },
    (v6/*: any*/),
    (v7/*: any*/)
  ],
  "storageKey": null
},
v9 = [
  (v0/*: any*/),
  (v5/*: any*/),
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "height",
        "value": 120
      },
      {
        "kind": "Literal",
        "name": "width",
        "value": 320
      }
    ],
    "kind": "ScalarField",
    "name": "logo",
    "storageKey": "logo(height:120,width:320)"
  },
  (v6/*: any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "Company",
  "kind": "LinkedField",
  "name": "companiesFirstDay",
  "plural": true,
  "selections": (v9/*: any*/),
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "Company",
  "kind": "LinkedField",
  "name": "companiesLastDay",
  "plural": true,
  "selections": (v9/*: any*/),
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "MainCollaborator",
  "kind": "LinkedField",
  "name": "mainCollaborator",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    (v5/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "height",
          "value": 320
        },
        {
          "kind": "Literal",
          "name": "width",
          "value": 1000
        }
      ],
      "kind": "ScalarField",
      "name": "logo",
      "storageKey": "logo(height:320,width:1000)"
    },
    (v6/*: any*/),
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "intro",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "video",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "poster",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "Event",
  "kind": "LinkedField",
  "name": "events",
  "plural": true,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "date",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timeStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timeEnd",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "location",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "pages_index_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MetaData",
        "kind": "LinkedField",
        "name": "currentMetaData",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v8/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WelcomeScreen_currentMetaData"
          }
        ],
        "storageKey": null
      },
      (v13/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "pages_index_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MetaData",
        "kind": "LinkedField",
        "name": "currentMetaData",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v0/*: any*/),
          (v8/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/)
        ],
        "storageKey": null
      },
      (v13/*: any*/)
    ]
  },
  "params": {
    "cacheID": "24a1752c608f888169669166adc95502",
    "id": null,
    "metadata": {},
    "name": "pages_index_Query",
    "operationKind": "query",
    "text": "query pages_index_Query {\n  currentMetaData {\n    ...WelcomeScreen_currentMetaData\n    id\n    year\n    startDate\n    endDate\n    interestForm\n    collaborators {\n      id\n      name\n      logo(width: 459, height: 170)\n      url\n      description\n    }\n    companiesFirstDay {\n      id\n      name\n      logo(width: 320, height: 120)\n      url\n    }\n    companiesLastDay {\n      id\n      name\n      logo(width: 320, height: 120)\n      url\n    }\n    mainCollaborator {\n      id\n      name\n      logo(width: 1000, height: 320)\n      url\n      description\n      intro\n      video\n      poster\n    }\n  }\n  events {\n    id\n    title\n    date\n    timeStart\n    timeEnd\n    location\n  }\n}\n\nfragment Countdown_currentMetaData on MetaData {\n  startDate\n  endDate\n}\n\nfragment WelcomeScreen_currentMetaData on MetaData {\n  year\n  startDate\n  endDate\n  interestForm\n  ...Countdown_currentMetaData\n}\n"
  }
};
})();
(node as any).hash = '1e6ca84273d9e47cc7088f903f4d0e43';
export default node;
